// import '../styles/main.scss';
import 'lazysizes';

import Alpine from 'alpinejs';
import persist from '@alpinejs/persist';
import collapse from '@alpinejs/collapse'
import { registerBundleThresholdsStore } from '../lib/alp-bundle-thresholds';

// Import Swiper
import Swiper from 'swiper';
// import 'swiper/swiper-bundle.css';
import { Autoplay, Navigation, Pagination, Thumbs, Mousewheel } from 'swiper/modules';

// import '../components/alp-main-store';
// import '../components/alp-cart';
// import '../components/alp-build-box'; // FE TODO Must be included only for the build box section

window.Alpine = Alpine;
window.Swiper = Swiper;
Swiper.use([Autoplay, Navigation, Pagination, Thumbs, Mousewheel]);

Alpine.plugin(persist);
Alpine.plugin(collapse);
registerBundleThresholdsStore(Alpine);
Alpine.start();

document.addEventListener('lazybeforeunveil', function(e){
    var bg = e.target.getAttribute('data-bg');
    if(bg){
        e.target.style.backgroundImage = 'url(' + bg + ')';
        e.target.removeAttribute('data-bg');
    }
}, false);

const productCardGallerySelector = '[data-product-card-gallery]';

const hydrateDeferredProductCardImages = (gallery) => {
    gallery.querySelectorAll('[data-deferred-image]').forEach((slide) => {
        if (slide.dataset.deferredImageLoaded === 'true') return;

        const img = document.createElement('img');

        img.src = slide.dataset.deferredImageSrc || '';
        img.srcset = slide.dataset.deferredImageSrcset || '';
        img.sizes = slide.dataset.deferredImageSizes || '';
        img.alt = slide.dataset.deferredImageAlt || '';
        img.loading = 'lazy';
        img.decoding = 'async';
        img.width = 360;

        slide.appendChild(img);
        slide.dataset.deferredImageLoaded = 'true';
    });
};

const updateProductCardGalleryPagination = (gallery) => {
    const pagination = gallery.parentElement?.querySelector('[data-product-card-pagination]');

    if (!pagination) return;

    const slides = gallery.querySelectorAll('.product-card__gallery-slide');

    if (!slides.length) return;

    const slideWidth = slides[0].clientWidth || gallery.clientWidth;
    const activeIndex = Math.min(
        slides.length - 1,
        Math.max(0, Math.round(gallery.scrollLeft / Math.max(slideWidth, 1)))
    );

    pagination.querySelectorAll('[data-product-card-dot]').forEach((dot, index) => {
        dot.classList.toggle('product-card__gallery-dot--active', index === activeIndex);
    });
};

const queueProductCardGalleryPaginationUpdate = (() => {
    let frameId = null;
    let activeGallery = null;

    return (gallery) => {
        activeGallery = gallery;

        if (frameId) return;

        frameId = window.requestAnimationFrame(() => {
            if (activeGallery) {
                updateProductCardGalleryPagination(activeGallery);
            }

            frameId = null;
            activeGallery = null;
        });
    };
})();

document.addEventListener('scroll', (event) => {
    const gallery = event.target instanceof Element ? event.target.closest(productCardGallerySelector) : null;

    if (!gallery) return;

    hydrateDeferredProductCardImages(gallery);
    queueProductCardGalleryPaginationUpdate(gallery);
}, { passive: true, capture: true });

['pointerenter', 'touchstart', 'focusin'].forEach((eventName) => {
    document.addEventListener(eventName, (event) => {
        const gallery = event.target instanceof Element ? event.target.closest(productCardGallerySelector) : null;

        if (!gallery) return;

        hydrateDeferredProductCardImages(gallery);
    }, { passive: true, capture: true });
});

window.addEventListener('resize', () => {
    document.querySelectorAll(productCardGallerySelector).forEach((gallery) => {
        updateProductCardGalleryPagination(gallery);
    });
}, { passive: true });

document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll(productCardGallerySelector).forEach((gallery) => {
        updateProductCardGalleryPagination(gallery);
    });
});

// import { variantSelect } from '../components/variant-select';
// import { headerSticky } from '../components/header';

// headerSticky();
// variantSelect();

if (window.innerWidth < 768) {
    let lastScrollTop = 0;
    const header = document.querySelector(".header-wrapper");

    window.addEventListener("scroll", () => {
        const scrollTop = window.scrollY || document.documentElement.scrollTop;
        const halfScreenHeight = window.innerHeight / 2;
    
        if (scrollTop > halfScreenHeight) {
          if (scrollTop > lastScrollTop) {
            header.classList.add("scroll-up");
          } else {
            header.classList.remove("scroll-up");
          }
        } else {
          
          header.classList.remove("scroll-up");
        }
    
        lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
    });
}

// window.addEventListener('load', () => {
//     const ratingItems = document.querySelectorAll('.product-card__rating');

//     ratingItems.forEach(item => {
//         console.log(item.shadowRoot);
//         if (item.shadowRoot) {
//             const shadow = item.shadowRoot;
//             const emptyStar = shadow.querySelectorAll('.gw-rv-avg-rating__star-empty');

//             console.log(emptyStar);
//           }
//     });
// });
